import { z } from "zod";

export const CmsMediaType = { IMAGE: "image", VIDEO: "video", AUDIO: "audio" } as const;
export const CmsMediaTypeSchema = z.enum([CmsMediaType.IMAGE, CmsMediaType.VIDEO, CmsMediaType.AUDIO]);
export type CmsMediaType = z.infer<typeof CmsMediaTypeSchema>;
